export default __webpack_public_path__ + "static/media/upes.0ce399e1.jpg";